import { useState } from "react";
import "../Segmentation Project/segmentation-project.css";
import { Button, Spinner, Box } from "@chakra-ui/react";
import axios from "axios";
import DisplayImage from "./displayImage";

function UploadImage() {
  const [selectedFile, setSelectedFile] = useState(null);
  const [error, setError] = useState(null);
  const [inputImage, setInputImage] = useState(null);
  const [outputImage, setOutputImage] = useState(null);
  const [isLoading, setIsloading] = useState(false);

  const fileUploadHandler = () => {
    setIsloading(true);
    const fd = new FormData();
    fd.append("file", selectedFile, selectedFile.name);
    axios
      .post(`/api/predict`, fd)
      .then((res) => {
        setInputImage(res.data.image);
        setOutputImage(res.data.mask);
        selectedFile(null);
        setError(null);
        setIsloading(false);
      })
      .catch((error) => {
        console.log(error);
        setSelectedFile(null);
        setError(error.data);
        setIsloading(false);
      });
  };

  const fileData = () => {
    if (selectedFile) {
      if (
        selectedFile.type === "image/jpeg" ||
        selectedFile.type === "image/png"
      ) {
        return (
          <div>
            {error ? (
              <div>file too large!!</div>
            ) : (
              <div>
                <Button
                  colorScheme='teal'
                  size='sm'
                  onClick={() => fileUploadHandler()}
                >
                  Upload!
                </Button>
              </div>
            )}
          </div>
        );
      } else {
        return (
          <div>
            <h4>Please choose an image to upload</h4>
          </div>
        );
      }
    } else {
      return (
        <div>
          <h4>Choose Photos</h4>
        </div>
      );
    }
  };

  return (
    <div>
      <input type='file' onChange={(e) => setSelectedFile(e.target.files[0])} />
      {fileData()}
      {isLoading ? (
        <Box mt={5}>
          <Spinner
            thickness='4px'
            speed='0.65s'
            emptyColor='gray.200'
            color='blue.500'
            size='xl'
          />
        </Box>
      ) : (
        <Box>
          <DisplayImage inputImage={inputImage} outputImage={outputImage} />
        </Box>
      )}
    </div>
  );
}
export default UploadImage;
